/**
 * Created by Jonas Wålekvist on 2018-06-26.
 */

export class DirtyWildsParticleConfig {
    public static mistParticles:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0
        },
        "scale" : {
            "start" : 0.5,
            "end" : 2,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#000000",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 50,
            "end" : 500,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : 10
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 265,
            "max" : 275
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -10,
            "max" : 10
        },
        "lifetime" : {
            "min" : 4.5,
            "max" : 5
        },
        "blendMode" : "add",
        "frequency" : 0.3,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : 600,
            "h" : 0
        }
    };

    public static winDisplayParticleConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.2,
            "end" : 0.2,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 1200,
            "end" : 1200,
            "minimumSpeedMultiplier" : 0.8
        },
        "acceleration" : {
            "x" : 0,
            "y" : 3000
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -110,
            "max" : -70
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -400,
            "max" : 400
        },
        "lifetime" : {
            "min" : 2.1,
            "max" : 2.1
        },
        "blendMode" : "normal",
        "frequency" : 0.002,
        "emitterLifetime" : 0.1,
        "maxParticles" : 50,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -100,
            "y" : -25,
            "w" : 200,
            "h" : 50
        }
    };

    public static winMultiplierParticleConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0
        },
        "scale" : {
            "start" : 1.0,
            "end" : 0.3,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#b8f9ff",
            "end" : "#3befff"
        },
        "speed" : {
            "start" : 1500,
            "end" : 0,
            "minimumSpeedMultiplier" : 0.5
        },
        "acceleration" : {
            "x" : 0,
            "y" : 0
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -200,
            "max" : 20
        },
        "noRotation" : true,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 0
        },
        "lifetime" : {
            "min" : 0.5,
            "max" : 1.5
        },
        "blendMode" : "add",
        "frequency" : 0.001,
        "emitterLifetime" : 0.1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "circle",
        "spawnCircle" : {
            "x" : 0,
            "y" : 0,
            "r" : 2
        }
    };

    public static bigWinStarParticles:any = {
        "alpha" : {
            "start" : 0.4,
            "end" : 1.0
        },
        "scale" : {
            "start" : 0.3,
            "end" : 1.0,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#fffbca"
        },
        "speed" : {
            "start" : 50,
            "end" : 1000,
            "minimumSpeedMultiplier" : 0.5
        },
        "acceleration" : {
            "x" : 0,
            "y" : 0
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 0
        },
        "lifetime" : {
            "min" : 0.5,
            "max" : 1.5
        },
        "blendMode" : "add",
        "frequency" : 0.001,
        "emitterLifetime" : 1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "point"
    };
}